/**
 * Получить лист наклеек и отдать его человеку.
 *
 * Вынесено в хук, потому что мест печати стало три — история партий, реестр
 * кодов и карточка единицы, — а внутри две неочевидные вещи, которые в третьей
 * копии обязательно потерялись бы:
 *
 * ⚠️ Ручка за авторизацией, токен лежит в localStorage и в `<a href>` не
 * попадёт — качаем fetch'ем в blob.
 *
 * ⚠️ На iOS атрибут `download` игнорируется, и файл отдаётся через
 * `navigator.share` — обязательно ДВУМЯ тапами: пока грузится PDF, user
 * activation от первого тапа протухает, и share падает с NotAllowedError.
 * Поэтому хук возвращает `readyFile`: вызывающий рисует вторую кнопку.
 */

import { useCallback, useState } from 'react';
import { isIosLike, canShareFile, shareFile, downloadBlob } from '../utils/fileShare';

export function useTagSheet() {
  const [busy, setBusy] = useState(false);
  const [readyFile, setReadyFile] = useState(null);
  const [error, setError] = useState(null);

  /** @param {() => Promise<{blob: Blob, filename: string}>} fetcher */
  const get = useCallback(async (fetcher) => {
    setBusy(true);
    setError(null);
    setReadyFile(null);
    try {
      const { blob, filename } = await fetcher();
      const file = new File([blob], filename, { type: 'application/pdf' });
      if (isIosLike() && canShareFile(file)) setReadyFile(file);
      else downloadBlob(blob, filename);
      return true;
    } catch (e) {
      setError(e?.message || 'PDF');
      return false;
    } finally {
      setBusy(false);
    }
  }, []);

  const share = useCallback(async () => {
    if (!readyFile) return;
    const r = await shareFile(readyFile);
    if (r !== 'cancelled') setReadyFile(null);
  }, [readyFile]);

  return { busy, readyFile, error, get, share };
}
